/**
 * @Self : Injecte la classe (le constructeur) dans la propriété.
 * Utilisable sur un champ simple : @Self _!: typeof MaClasse;
 */
export function Self(_value: undefined, context: ClassFieldDecoratorContext) {
  if (context.kind !== 'field') {
    throw new Error('@Self ne peut être utilisé que sur un champ (field).');
  }

  // On enregistre une fonction qui s'exécutera à la création de l'instance
  context.addInitializer(function (this: any) {
    // On assigne le constructeur à la propriété (ex: '_')
    this[context.name] = this.constructor;
  });
}
